// src/components/Footer.js
import React from 'react';
import logo from "../assets/FooterBg.png"; // If you want to use the logo somewhere
import '../App.css';



const footerStyle = {
  background: "#13499C",
  color: "#fff",
  textAlign: "center",
  padding: "0 0 0 0",
  position: "relative",
  bottom: 0,
  width: "100%",
};

const footerBar = {   
  // background: "#000 ",
  // color: "#fff",
  // padding: "1rem 1rem",
  // marginTop: 0, // Explicitly set to 0 (optional)
};

const topbar_wrap = {
  display: "flex",
  justifyContent: "space-between",
  
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "0.0rem 0",
};

const Footer = () => ( 
  
  <footer style={footerStyle}>
    <div style={footerBar} >
      <div style={topbar_wrap}>
         
        <div className="top-bar_address">
  {/* First row: "12+" and "years Anniversary" */}
  <div className="row mb-3 ">
  <div className="col-auto">
    <span className="fancy-animated-number">12 year Anniversary </span>
    <div style={{ marginTop: "0rem", fontSize: "0.9rem" }}>
    <span style={{ marginLeft: '00px' }}>
  <i className="fas fa-map-marker-alt"></i> Bengaluru, Karnataka
</span>
</div>
</div>
</div>



  {/* Second row: Input and button */}
  {/* <form className="row">
    <div className="col mb-2">
    <input
type="email"
placeholder="Your Email ID"
className="flex-1 bg-black text-white px-4 py-2 border border-gray-500 outline-none mb-2 sm:mb-0 sm:mr-2 placeholder:text-gray-400"/>
    </div>
    <div className="col-auto">
      <button type="submit" className="btn btn-outline-warning">
        Send Mail
      </button>
    </div>
  </form> */}
</div>

       
{/* <div className="right">
    <div className="top-bar_contact">
    <h4 className="text-lg font-semibold mb-3">Contact</h4>
    <a 
  className="text-secondary fs-6 mb-1 d-block contact-link" 
  href="https://wa.me/917090009800" 
  target="_blank" 
  rel="noopener noreferrer"
>
  WhatsApp: 9611703676
</a>
<a 
  className="text-secondary fs-6 mb-1 d-block contact-link" 
  href="tel:+917090009800"
>
  Call: 9611703676
</a>
<a 
  className="text-secondary fs-6 mb-1 d-block contact-link" 
  href="mailto:s.b.kasoju@gmail.com"
>
  Email:marketing@akruthipeb.com
</a>


    </div>
</div> */}
</div>
</div>
    <div style={{ marginTop: "1rem", fontSize: "0.9rem" }}>
    <p>      © {new Date().getFullYear()} Akruthi Engineered Building Solutions. All rights reserved.
    This website is developed and maintained by Manjunath Sungar.
    </p>
    </div>
  </footer>
);

export default Footer;
